var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 200,
    viewBox: "0 0 647 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5H177.5V185.5H7.5V15.5ZM237.603 184.5L332 21L426.397 184.5H237.603ZM639.5 100C639.5 151.086 598.086 192.5 547 192.5C495.914 192.5 454.5 151.086 454.5 100C454.5 48.9137 495.914 7.5 547 7.5C598.086 7.5 639.5 48.9137 639.5 100Z",
    stroke: "white",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.67a75dd37e293e1d3489f721bee3a298.svg";
export { ForwardRef as ReactComponent };